import { Template } from './template';
import { CardSvg } from './card-svg';

export class Update {
  old_name: string | undefined;
  card_id: string | null;
  enabled: boolean;
  template_id: string;
  second_product_id: string;
  v1_price_text: string;
  v2_price_text: string;
  name: string;
  brand: string;
  type: string;
  photo: string;
  usps: {id:string, value:string}[];

  static getValueIfItExists(id:string, container:any):any {
    let element = container.querySelector(id);
    let output = null;
    if (element) {
      output = element.textContent;
    }
    return output;
  }

  static getPhoto(container:any):any {
    let element = container.querySelector('.photo');
    let output = null;
    if (element) {
      output = element;
    }
    return output;
  }

  static extractUSPS(container_element:any):{id:string, value:string}[] {
    // Make an empty array that will contain all USPS rows
    let svg_usps:{id:string, value:string}[] = [];
    if (container_element.querySelector('.usps')) {
      let usps_element = container_element.querySelector('.usps');
      // If our container has a .usps class, loop over each child
      for (let i = 0; i < usps_element.children.length; i++) {
        let row_element = usps_element.children[i];
        let row_id = row_element.getAttribute('class');
        let row_content = row_element.textContent;
        svg_usps.push({id: row_id, value: row_content});
      }
    }
    return svg_usps;
  }

  constructor(inputTemplate:Template, oldName:string = undefined) {
    this.old_name = oldName;
    let cardSvg = new CardSvg(inputTemplate.svg);
    let container = document.createElement('div');
    container.innerHTML = inputTemplate.svg;
    let svg_brand = cardSvg.getValueIfItExists(CardSvg.brand_selector);
    let image = Update.getPhoto(container);
    if (image) {
      this.photo = image.getAttributeNS('http://www.w3.org/1999/xlink', 'href');
    }
    let svg_usps:{id:string, value:string}[] = Update.extractUSPS(container);

    this.template_id = inputTemplate.template_id;
    this.card_id = inputTemplate.card_id;
    this.brand = svg_brand;
    this.name = inputTemplate.name;
    this.type = cardSvg.getValueIfItExists(CardSvg.type_selector);
    this.enabled = inputTemplate.enabled;

    // If our update accepts a second product, check if any values are configured.
    if (inputTemplate.allow_second_product && inputTemplate.second_product_id) {
      this.second_product_id = inputTemplate.second_product_id;
      this.v1_price_text = cardSvg.getValueIfItExists(CardSvg.v1_price_text_selector);
      this.v2_price_text = cardSvg.getValueIfItExists(CardSvg.v2_price_text_selector);
    }

    this.usps = svg_usps;
  }
}



// WEBPACK FOOTER //
// /app/src/app/_models/update.ts